import './setup';

import { Crisp } from '@affine/core/components/crisp';
import { Telemetry } from '@affine/core/components/telemetry';
import { TynkPixel } from '@affine/core/components/tynk-pixel';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './app';

function mountApp() {
  // oxlint-disable-next-line @typescript-eslint/no-non-null-assertion
  const root = document.getElementById('app')!;
  createRoot(root).render(
    <StrictMode>
      <Telemetry />
      <Crisp />
      <TynkPixel />
      <App />
    </StrictMode>
  );
}

try {
  mountApp();
} catch (err) {
  console.error('Failed to bootstrap app', err);
}
